module.exports = __webpack_public_path__ + "img/3.4b9baa00.png";